import React from 'react';
import { RechartsDotProps } from './types';

interface Props<T> extends RechartsDotProps<T> {
  stroke?: string;
  active?: boolean;
}

export default function LineChartDot<T>({
  stroke = '#fff',
  active,
  ...props
}: Props<T>) {
  return (
    <circle {...props} stroke={stroke} fill={active ? stroke : '#fff'}></circle>
  );
}
